module.exports = __webpack_public_path__ + "od-check-circle-icon/od-check-circle-icon-768801fa1c10cf051feaaabacd7987dd.svg";